/// <amd-module name="VSS/Features/Directory/components/DirectoryGrid/GroupRow" />
import { IGroupRow, IGroupRowProps } from "./DirectoryGrid.Props";
import { DirectoryCSS } from "./DirectoryGridConstants";
import { DetailsRow, IColumn } from "OfficeFabric/DetailsList";
import * as React from "react";
import { css } from "VSS/Platform/Layout";
import { Tooltip } from "VSSUI/TooltipEx";
import { KeyCode } from "VSSUI/Util";
import { VssIcon, VssIconType } from "VSSUI/VssIcon";

/** Renders a toggleable row */
export class GroupRow extends React.PureComponent<IGroupRowProps> {
    public render(): JSX.Element {
        const {
            row: { collapsed, title, toggleable }
        } = this.props;

        return (
            <div onClick={this._onClicked} onKeyDown={this._onKeyDown}>
                <DetailsRow
                    {...this.props}
                    aria-label={title}
                    aria-expanded={!collapsed}
                    onRenderItemColumn={this._renderCell}
                    className={css("directory-group-row", !toggleable && "directory-group-row--disabled")}
                />
            </div>
        );
    }

    private _renderCell = (row: IGroupRow, index: number, column: IColumn): JSX.Element | undefined => {
        return GroupRow.RenderCell(row, index, column, this.props.columnKey);
    };

    public static RenderCell = (row: IGroupRow, index: number, renderingColumn: IColumn, targetColumnKey: string): JSX.Element | undefined => {
        if (renderingColumn.key === targetColumnKey) {
            return (
                <div className={DirectoryCSS.DIRECTORY_ROWITEM}>
                    {row.toggleable && (
                        <VssIcon
                            className={css("directory-group-chevron", !row.collapsed && "expanded")}
                            iconName="ChevronRight"
                            iconType={VssIconType.fabric}
                        />
                    )}
                    {row.iconProps && <VssIcon {...row.iconProps} className="directory-group-icon" />}
                    <Tooltip overflowOnly={true} text={row.title}>
                        <div className="directory-row-group-title flex flex-center text-ellipsis">{row.title}</div>
                    </Tooltip>
                </div>
            );
        }
    };

    private _onClicked = (): void => {
        const { row, onToggled } = this.props;

        if (onToggled && row.toggleable) {
            onToggled(row, !row.collapsed);
        }
    };

    private _onKeyDown = (event: React.KeyboardEvent<HTMLElement>): void => {
        const { row, onToggled } = this.props;

        if (onToggled && row.toggleable) {
            if ((!row.collapsed && event.keyCode === KeyCode.rightArrow) || (row.collapsed && event.keyCode === KeyCode.leftArrow)) {
                onToggled(row, !row.collapsed);
                event.preventDefault();
            }
        }
    };
}
